export default "__VITE_ASSET__CNH$EypR__"